import React, { useState, useEffect, Suspense, lazy } from "react";
import { useParams } from "react-router-dom";
import {
  Box,
  Grid,
  Button,
  Text,
  useDisclosure,
  Spinner,
  useToast,
} from "@chakra-ui/react";
import { FaPlus, FaPrint, FaSync } from "react-icons/fa";
import { DragDropContext } from "react-beautiful-dnd";
import Assign_T from "./Assign_T"; // Import the Assign_T drawer component
import { Link } from "react-router-dom";
import { BASE_URL } from "../../Globalapi/Globalapi";

const ClassStudents = lazy(() => import("./Class_students"));
const AvailableStudents = lazy(() => import("./Avail_Stude"));

const fetchClasses = async () => {
  try {
    const school_id = sessionStorage.getItem("school_id"); // If JWT is needed

    const response = await fetch(
      `${BASE_URL}/admin/class/list_all_class.php?school_id=${school_id}`
    );
    const result = await response.json();
    return result.data || [];
  } catch (error) {
    console.error("Error fetching classes:", error);
    return [];
  }
};

const fetchAssignedStudents = async (class_details_id) => {
  try {
    const response = await fetch(
      `${BASE_URL}/admin/class/list_assigned_students.php?class_details_id=${class_details_id}`
    );
    console.log("ash", response);

    const result = await response.json();
    console.log("ash", result.data);

    return result.data || [];
    console.log("ash", result.data);
  } catch (error) {
    console.error("Error fetching assigned students:", error);
    return [];
  }
};

const fetchUnassignedStudents = async () => {
  try {
    const school_id = sessionStorage.getItem("school_id"); // If JWT is needed

    const response = await fetch(
      `${BASE_URL}/admin/class/unassigned_students_list.php?school_id=${school_id}`
    );
    const result = await response.json();
    return result.data || [];
  } catch (error) {
    console.error("Error fetching unassigned students:", error);
    return [];
  }
};

const ClassPage = () => {
  const { classId } = useParams();
  const [classStudents, setClassStudents] = useState([]);
  const [unassignedStudents, setUnassignedStudents] = useState([]);
  const [assignedTeacher, setAssignedTeacher] = useState(null);
  const { isOpen, onOpen, onClose } = useDisclosure();
  const toast = useToast();

  // Define refresh functions
  const loadAssignedStudents = async () => {
    try {
      const students = await fetchAssignedStudents(classId);
      setClassStudents(students);
    } catch (error) {
      toast({ title: "Failed to load assigned students.", status: "error" });
    }
  };

  const loadUnassignedStudents = async () => {
    try {
      const students = await fetchUnassignedStudents();
      setUnassignedStudents(students);
    } catch (error) {
      toast({ title: "Failed to load unassigned students.", status: "error" });
    }
  };

  const loadClassData = async () => {
    try {
      const classes = await fetchClasses();
      const classData = classes.find((c) => c.id === classId);
      if (classData) {
        setAssignedTeacher(`Teacher Name: ${classData.name}`); // Replace with actual teacher name if available
      }
    } catch (error) {
      toast({ title: "Failed to load class data.", status: "error" });
    }
  };

  useEffect(() => {
    let isMounted = true; // flag to track component mount status

    const fetchData = async () => {
      try {
        await loadClassData();
        if (isMounted) {
          await Promise.all([loadAssignedStudents(), loadUnassignedStudents()]);
        }
      } catch (error) {
        console.error("Error fetching initial data:", error);
      }
    };

    fetchData();

    return () => {
      isMounted = false; // set flag to false when component unmounts
    };
  }, [classId]);

  const handleAddStudent = async (student) => {
    try {
      const response = await fetch(
        `${BASE_URL}/admin/class/assign_students.php`,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify({
            class_details_id: classId,
            student_id: student.id,
            action: "assign_student",
            school_id: sessionStorage.getItem("school_id"), // School ID
          }),
        }
      );

      const result = await response.json();
      if (response.ok && result.status === "success") {
        toast({ title: "Student added successfully.", status: "success" });
        await Promise.all([loadAssignedStudents(), loadUnassignedStudents()]);
      } else {
        console.error(
          "Failed to add student to class:",
          result.message || "Unknown error"
        );
      }
    } catch (error) {
      console.error(
        "Error assigning student to class:",
        error.message || error
      );
    }
  };

  const handleRemoveStudent = async (student) => {
    const p = {
      id: student.id,
      action: "remove_student",
      // pass:sessionStorage.getItem('user_id'),
    };
    console.log(p);

    try {
      const response = await fetch(
        `${BASE_URL}/admin/class/assign_students.php`,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify({
            id: student.id,
            action: "remove_student",
            school_id: sessionStorage.getItem("school_id"), // School ID
          }),
        }
      );
      console.log(response);

      const result = await response.json();
      if (response.ok && result.status === "success") {
        toast({ title: "Student removed successfully.", status: "success" });
        // Refresh the lists after removal
        await Promise.all([loadAssignedStudents(), loadUnassignedStudents()]);
      } else {
        console.error(
          "Failed to remove student from class:",
          result.message || "Unknown error"
        );
      }
    } catch (error) {
      console.error(
        "Error removing student from class:",
        error.message || error
      );
    }
  };

  const handleAssignTeacher = async (teacher) => {
    setAssignedTeacher(teacher);
    onClose();
  };

  const onDragEnd = async (result) => {
    const { source, destination } = result;

    if (!destination) return; // No destination means dropped outside

    // Logic to handle adding a student
    if (
      source.droppableId === "availableStudents" &&
      destination.droppableId === "classStudents"
    ) {
      const student = unassignedStudents[source.index];
      await handleAddStudent(student);
    }
    // Logic to handle removing a student
    else if (
      source.droppableId === "classStudents" &&
      destination.droppableId === "availableStudents"
    ) {
      const student = classStudents[source.index];
      await handleRemoveStudent(student);
    }
  };

  return (
    <Box bg="white" shadow="md">
      <div className="teacher-list-container">
        {/* Header */}
        <div className="header">
          <h1 style={{ fontSize: "20px", margin: 0 }}>Class-Students Assign</h1>{" "}
          {/* Remove default margin */}
          <div className="action-buttons">
            {/* <Button
              onClick={() => window.location.reload()}
              boxShadow="md"
              backgroundColor="white"
              fontSize="11px"
            >
              <FaSync color="#515B73" />
            </Button> */}
            <Button
              display={{ base: "none", md: "flex" }}
              backgroundColor="white"
              fontSize="11px"
              boxShadow="md"
            >
              <FaPrint color="#515B73" />
              Print PDF
            </Button>
          </div>
        </div>

        {/* Breadcrumb */}
        <div className="breadcrumb">
          <Link
            to="/admin"
            style={{ textDecoration: "none", color: "inherit" }}
          >
            <span>Dashboard</span>
          </Link>{" "}
          /{" "}
          <Link
            to="/class/list"
            style={{ textDecoration: "none", color: "inherit" }}
          >
            <span>Class List</span>
          </Link>{" "}
          / <span> Student Assign </span>
        </div>
        <Box mt={6}>
          <Suspense fallback={<Spinner size="lg" />}>
            <DragDropContext onDragEnd={onDragEnd}>
              <Grid
                templateColumns={{
                  base: "repeat(1, 1fr)",
                  md: "repeat(3, 1fr)",
                }} // 1 column on mobile, 3 on larger screens
                gap={6}
              >
                <ClassStudents
                  classStudents={classStudents}
                  onRemoveStudent={handleRemoveStudent} // Pass down the remove student function
                />
                <AvailableStudents
                  availableStudents={unassignedStudents}
                  handleAddStudent={handleAddStudent}
                  loading={unassignedStudents.length === 0}
                />
                <Box
                  p={5}
                  border="1px"
                  borderColor="gray.200"
                  borderRadius="md"
                >
                  <Text fontSize="lg" fontWeight="bold" mb={4}>
                    Assigned Teacher
                  </Text>
                  <Text mb={4}>{assignedTeacher || "No teacher assigned"}</Text>
                  <Button
                    colorScheme="blue"
                    leftIcon={<FaPlus />}
                    onClick={onOpen}
                  >
                    Assign Teacher
                  </Button>
                </Box>
              </Grid>
            </DragDropContext>
          </Suspense>

          <Assign_T
            isOpen={isOpen}
            onClose={onClose}
            onAssignTeacher={handleAssignTeacher}
          />
        </Box>
      </div>
    </Box>
  );
};

export default ClassPage;
